<template lang="pug">
.switcher-el-container
  .modal.is-active.is-clipped(@click="closeCoinSwitcher()", v-if="showCoinSwitcher")
    .modal-background
    .modal-card(@keydown.esc="closeCoinSwitcher()", tabindex="0", :id="idModal")
      .modal-card-body(@click.stop="")
        coin-list(
          @selected="selectCoin"
        )
    .modal-close(@click="closeCoinSwitcher()")
  span.coin-switcher(
    :id="id"
    tabindex="0"
    @keydown.enter="openCoinSwitcher()"
    @click="openCoinSwitcher()"
    :aria-label=" (isMobile || compact ? 'Choose' : 'Click to choose') + ' from 80+ different crypto coins & tokens!'"
    :class="{ 'hint--always': showHint && !compact, 'hint--top': hintTop && !isMobile && !compact, 'hint--right': !hintTop && !isMobile && !compact, 'hint--bottom': isMobile && !compact, 'compact hint--bottom-right': compact }"
  )
    .coin-symbol(v-if="!compact")
      div {{ coin }}
      .coin-name-small {{ coinName }}
    img(:src="coinLogo")
    //- i.fa.fa-exchange
</template>

<script>
import { nanoid } from 'nanoid'
import CoinList from '../components/c_coin_list'
export default {
  name: 'c_coin_switcher',
  components: {
    CoinList
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      showHint: false,
      isLoading: true
    }
  },
  computed: {
    showCoinSwitcher() {
      return this.$store.getters.showCoinSwitcher
    },
    coin() {
      return this.$store.getters.coinSymbol
    },
    coinLogo() {
      if (!this.compact) return this.$store.getters.coinData.logo
      else return this.$store.getters.preCoinLogo
    },
    coinName() {
      return this.$store.getters.coinData.name
    },
    id() {
      return 'coin-switcher-container-' + nanoid(10)
    },
    idModal() {
      return 'coin-switcher-modal-' + nanoid(10)
    }
  },
  watch: {
  },
  props: ['hintTop', 'compact'],
  mounted() {
    let vm = this
    vm.isLoading = true
    vm.closeCoinSwitcher()

    vm.$store.dispatch('shouldShowHint').then((show) => {
      vm.showHint = show
      if (show) {
        let intervalHintRemove = setInterval(async function () {
          clearInterval(intervalHintRemove)
          vm.$store.dispatch('setHintSwitchCoinTime', +new Date())
          vm.showHint = false
        }, 5000)
      }
    })
    if (document.getElementById(vm.idModal)) document.getElementById(vm.idModal).focus();
  },
  methods: {
    selectCoin(o) {
      let vm = this
      if (vm.compact) {
        vm.$store.dispatch('setPreCoin', { coin: o.symbol }).then(() => {
          vm.closeCoinSwitcher()
          vm.$emit('selected', o)
        }).catch((err) => {
          console.error(err)
        })
      } else {
        vm.$store.dispatch('setCoin', { coin: o.symbol }).then(() => {
          vm.$store.dispatch('addToCoinList', vm.coin)
          vm.$emit('selected', o)
          if (document.getElementById(vm.id)) document.getElementById(vm.id).focus();
          vm.closeCoinSwitcher()
        }).catch((err) => {
          console.error(err)
        })
      }
    },
    openCoinSwitcher() {
      let vm = this
      document.querySelector('html').style.overflow = 'hidden'
      vm.$store.dispatch('openCoinSwitcher')
    },
    closeCoinSwitcher() {
      let vm = this
      document.querySelector('html').style.removeProperty('overflow')
      vm.$store.dispatch('closeCoinSwitcher')
      vm.$root.$emit('clearListeners')
    }
  }
}
</script>

<style lang="stylus" scoped>

.switcher-el-container
  display: inline-block
  .modal
    justify-content: flex-start
    .modal-card
      padding-top: 80px;
      padding-bottom: 40px;
      max-height: calc(100vh - 80px);

/* .switcher-el-container .modal-background
  background-color #fff */

.modal
  z-index: 1000002;
.address-field
  font-family: 'Azeret Mono', monospace;

.coin-switcher.compact
  width: 24px;
  height: 23.75px;
  img
    width 10px
    vertical-align: bottom
    margin-top 1px

.coin-switcher:not(.compact)
  box-shadow: 2px 2px 0px 0px #d1d1d1;
  background: whitesmoke;
  padding: 5px 10px 10px 25px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 400;
  vertical-align: middle;
  font-size: 2.1rem;
  line-height 1.5
  transition: box-shadow ease .2s;
  outline none
  .coin-symbol
    font-weight 700
    color #4a4a4a
    display: inline-block
    vertical-align: middle
    .coin-name-small
      font-size: 10px;
      margin-top: -10px;
      margin-left: 2px;
      font-weight: 400;
  span, b, img
    vertical-align middle
    font-weight: 700;
  img
    margin: 0px 10px 0px 12px;
    width: 32px;
    min-width: 32px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 5px
  &:after
    font-weight: 300;
    width: 200px;
    white-space: break-spaces;
    line-height: 16px;
    bottom: 36%;
  &.hint--top:after, &.hint--top:before
    bottom 100%
  &.hint--bottom:after, &.hint--bottom:before
    bottom: initial;
    -webkit-transform: translateX(-43%) translateY(8px);
    -moz-transform: translateX(-43%) translateY(8px);
    transform: translateX(-43%) translateY(8px);
  &:hover, &:focus
    box-shadow: 2px 2px 4px 0px #d1d1d1;
  i
    font-size: 19px;
    color: #c5c5c5;
    display: inline-block;
    vertical-align: middle;

@media screen and (min-width: 769px), print
  .modal-card, .modal-content
    width 720px

@media (max-width: 720px)
  .modal-card, .modal-content
    margin: 0 20px;
    position: relative;
    width: 100%;
  .modal-card
    padding-left: 20px;
    padding-right: 20px;

.down-modal
  width 100%
  .address-container
    width 100%
    padding: 15px;
    font-weight: 700;
    border: 2px dashed #efefef;
    font-size: 18px;
    word-break: break-word;

.modal-close
  &::before
    width 15px
  &::after
    height 15px
.modal-background
  background-color rgba(10,10,10,.6)
  cursor: pointer

.modal-close
  height: 40px;
  width: 40px;
  max-height: 40px;
  max-width: 40px;
  &:before
    width: 25px;
  &:after
    height: 25px;
.modal-card-body
  border-radius 5px
  font-size: 1rem;
  font-weight: 300;
  padding 0
  overflow hidden
    
html.dark
  i
    color #969696
  .modal-card-body
    background-color #2c2c2c
  .description
    color #fff
  .coin-switcher .coin-symbol
    color #4a4a4a

@media (max-width: 768px)
  .modal-card
    padding-left 20px
    padding-right 20px

@media (max-width: 450px)
  .modal-card
    margin-top 30px
  .switcher-el-container
    .modal
      .modal-card
        padding-top: 40px;
        max-height: calc(100vh - 40px);
</style>



// WEBPACK FOOTER //
// c_coin_switcher.vue?d565eafe